module.exports = __webpack_public_path__ + "static/media/choithramsPepsiProductThree.a9230906.jpg";